export const focusRingVar = "--flux-focus-ring";
export const focusRingVal = `var(${focusRingVar}, 0 0 0 0 transparent)`;
